export interface AllocationViewAvailableCompartmentDock {
  id: number;
  name: string;

  // internal
  isSelected?: boolean;
}

export interface AllocationViewAvailableCompartment {
  docks: AllocationViewAvailableCompartmentDock[];
  id: number;
  name: string;

  // internal
  isSelected?: boolean;
}

export interface AllocationViewAvailableDocksModel {
  compartments: AllocationViewAvailableCompartment[];
}
